export default "__VITE_ASSET__BxKxXr8H__"